import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AngularLoginConfig, LoginData } from '../../models';

export class PortaleCalcio {
    nome: string;
    valore: string;
    selected: boolean;
}

@Component({
    moduleId: module.id,
    selector: 'angular-login',
    templateUrl: 'angular-login.html'
})
export class AngularLoginComponent {
    @Input() loginConfig: AngularLoginConfig;
    @Input() listaPortali: Array<PortaleCalcio>;
    @Output() doLogin = new EventEmitter();
    loginInfo: FormGroup;
    comboValue: any;
    constructor(private fb: FormBuilder) {
        this.loginInfo = fb.group({
            'userId': '',
            'password': ''
        })
    }

    onSubmit() {
        let loginData: LoginData = this.loginInfo.value;
        this.doLogin.emit(loginData);
    }
}




// WEBPACK FOOTER //
// ./src/angular_library/components/login/angular-login.component.ts